import { Component, EventEmitter, Output } from "@angular/core";
import { Observable } from "rxjs";
import { TariffaLegale, TariffaLegaleIncaricato, } from "src/app/common/models/tariffa";
import { Cpa } from "src/app/common/models/tipologiche/cpa";
import { Iva } from "src/app/common/models/tipologiche/iva";
import { HelpersService } from "src/app/core/services/helpers.service";

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: "app-legali-modifica-tariffa-modal",
  templateUrl: "./legali-modifica-tariffa-modal.component.html",
})
export class LegaliDetaglioTariffaModalComponent {
  cpaOptions$: Observable<Cpa[]>;
  ivaOptions$: Observable<Iva[]>;
  isModifica: boolean = false;
  riepilogo: boolean = false;
  tariffa: TariffaLegaleIncaricato | TariffaLegale;
  @Output() modifica = new EventEmitter<
    TariffaLegaleIncaricato | TariffaLegale
  >();

  flagIVA: boolean;
  flagCPA: boolean;

  constructor(private helpers: HelpersService) {
    this.cpaOptions$ = this.helpers.getCpa();
    this.ivaOptions$ = this.helpers.getIva();
  }

  show(
    tariffa: TariffaLegaleIncaricato | TariffaLegale,
    isModifica: boolean = true
  ) {
    this.riepilogo = !isModifica;
    this.isModifica = isModifica;
    this.tariffa = { ...tariffa };
    this.flagIVA = !!this.tariffa.iva;
    this.flagCPA = !!this.tariffa.cpa;
    openModal("legaliModificaTariffaModal");
  }

  private salvaTariffa() {
    // if (this.tariffa instanceof TariffaLegaleIncaricato) {
    this.tariffa.revisionata = true;
    this.tariffa.totaleSpese = this.totaleTariffa;
    this.modifica.emit(this.tariffa);
    closeModal("legaliModificaTariffaModal");
    // }
  }

  get totaleTariffa() {
    //let maggiorazione = this.tariffa.maggiorazione ? this.tariffa.maggiorazione : 0;
    let speseEsenti = this.tariffa.speseEsenti ? this.tariffa.speseEsenti : 0;
    let totale = this.totaleImponibile + speseEsenti;
    if (this.tariffa.iva) {
      totale += this.totaleImponibile * this.tariffa.iva.valore / 100;
    }
    return totale;
  }

  get totaleCompensi(){
    let totale = 0
    totale = this.tariffa.imponibile + this.maggiorazioneCalc
    return totale;
  }

  get cpaCalc() {
    let cpa
    let spesePieDiLista = this.tariffa.spesePiePagina ? this.tariffa.spesePiePagina : 0
      if(this.tariffa.cpa)
        //cpa = (this.speseGenerali + this.tariffa.imponibile + spesePieDiLista) * (this.tariffa.cpa.valore / 100);
        cpa = this.totaleCompensi * this.tariffa.cpa.valore / 100;
        else
            cpa = 0
    return cpa
  }

  get speseGenerali(){
    let speseGenerali
      if(this.tariffa.speseGenerali)
        speseGenerali = this.totaleCompensi * this.tariffa.speseGenerali / 100;
        else speseGenerali = 0
    return speseGenerali
  }

  get totaleImponibile() {
    let spesePieDiLista = this.tariffa.spesePiePagina ? this.tariffa.spesePiePagina : 0
    let totaleImponibile = this.totaleCompensi + this.speseGenerali + this.cpaCalc + spesePieDiLista;
    return totaleImponibile;
  }

  get maggiorazioneCalc(){
      let maggiorazione = 0;
      if(this.tariffa.imponibile && this.tariffa.maggiorazione){
          maggiorazione = this.tariffa.imponibile * this.tariffa.maggiorazione / 100
      }
      return maggiorazione
  }

  private ripristinaTariffaOriginale() {
    // if (this.tariffa instanceof TariffaLegaleIncaricato) {
    const tariffaOriginale = (this.tariffa as TariffaLegaleIncaricato)
      .tariffaOriginale;
    this.tariffa.attivita = tariffaOriginale.attivita;
    this.tariffa.grado = tariffaOriginale.grado;
    this.tariffa.iva = tariffaOriginale.iva;
    this.tariffa.cpa = tariffaOriginale.cpa;
    this.tariffa.imponibile = tariffaOriginale.imponibile;
    this.tariffa.speseGenerali = tariffaOriginale.speseGenerali;
    this.tariffa.speseEsenti = tariffaOriginale.speseEsenti;
    this.tariffa.spesePiePagina = tariffaOriginale.spesePiePagina;
    this.tariffa.maggiorazione = tariffaOriginale.maggiorazione;
    this.tariffa.totaleSpese = tariffaOriginale.totaleSpese;
    this.tariffa.revisionata = tariffaOriginale.revisionata;
    // }
  }
}
